<template>
  <vl-region class="header">
    <vl-layout>
      <vl-grid mod-space-between mod-v-center>
        <vl-column width="2" class="header-title">
          <div test-id="header-go-to-home" @click="goToHome()">
            <span v-vl-text.bold>DOWNLOAD</span><br />TOEPASSING
          </div>
        </vl-column>
        <vl-column width="2">
          <div>
            <span
              v-vl-text.bold
              test-id="header-go-to-download"
              class="hover-pointer hover-underline-animation"
              @click="goToDownloads()"
              >Mijn downloads</span
            >
          </div>
        </vl-column>
      </vl-grid>
    </vl-layout>
  </vl-region>
</template>

<script lang="ts" src="./dl-header.ts"></script>

<style lang="scss" scoped src="./dl-header.scss"></style>
